import FooterOne from '../Footer/FooterOne';
import Header from '../Header/HeaderOne';
import { pageTitle } from '../PageTitle';
import React, { useEffect, useMemo, useState } from 'react';
import Preloader from '../Preloader/Preloader';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase/config';
import useScamStore from '../../store/scamStore';
import ReactPaginate from 'react-paginate';
import '../../assets/sass/Pagination.css'


const ScamPage = () => {
    pageTitle("SCAM LIST")
    const [viewRating, setViewRating] = useState([]);
    const { scam, setScam, isLoading, setLoading } = useScamStore();
    const [searchInputState, setSearchInputState] = useState('');


    const fetchData = async () => {
        setLoading(true);
        try {
            const querySnapshot = await getDocs(collection(db, 'scam'));
            const data = querySnapshot.docs.map(doc => doc.data());
            setScam(data);
            localStorage.setItem('scamLastFetchTime', Date.now().toString());
            localStorage.setItem('scam', JSON.stringify(data));
        } catch (error) {
            console.error('Ошибка при загрузке данных:', error);
        } finally {
            setLoading(false);
        }
    };

    const shouldFetchData = () => {
        const lastFetchTime = localStorage.getItem('scamLastFetchTime');
        const currentTime = Date.now();
        const twelveHoursInMillis = 12 * 60 * 60 * 1000;

        return !lastFetchTime || (currentTime - parseInt(lastFetchTime)) > twelveHoursInMillis;
    };

    useEffect(() => {
        const storedScam = localStorage.getItem('scam');
        if (shouldFetchData()) {
            fetchData(); 
        } else if (storedScam) {
            setScam(JSON.parse(storedScam));
            setLoading(false)
        }
    }, []); 

    useEffect(() => {
        if (scam.length > 0) {
            setViewRating(scam);
        }
    }, [scam]);

    const filteredRating = useMemo(() => {
        return viewRating.filter(el => el.nameOrg.toLowerCase().includes(searchInputState.trim().toLowerCase()));
    }, [viewRating, searchInputState]);

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 9;

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        window.scrollTo(0, 0)
    };

    const offset = currentPage * itemsPerPage;
    const currentItems = filteredRating.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(filteredRating.length / itemsPerPage);

    return <>
        {
            !isLoading ? <>
                <Header></Header>
                    <div className="services__page section-padding">
                        <div className="container">
                            <div className="row mb-30">
                                <div className="col-xl-6 col-lg-8">
                                    <div style={{marginBottom: '20px'}} className="services__page-title lg-t-center">
                                        <span className="subtitle">Scam list</span>
                                    </div>
                                    <div style={{marginTop: '10px'}} >
                                        <p>Search</p>
                                        <input placeholder='Org name' style={{backgroundColor: 'transparent'}} type="text" value={searchInputState} onChange={e => setSearchInputState(e.target.value)} />
                                    </div>
                                    <ReactPaginate
                                        previousLabel={'<'}
                                        nextLabel={'>'}
                                        breakLabel={'..'}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={2}
                                        onPageChange={handlePageClick}
                                        containerClassName={'pagination-tme'}
                                        activeClassName={'active'}
                                        disabledClassName={'disabled'}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                {currentItems.map((item, id)=>(
                                    <>
                                        <div className="col-xl-12" key={id}>
                                            <div className="services__page-item media-rating-container">
                                                <div style={{marginBottom: '0', justifyContent: 'space-between'}} className="services__page-item-left">
                                                    <div style={{width: '60%'}} className="services__page-item-left-content">
                                                        <h4 style={{width: '100%%'}}><p style={{color: 'red', width: '100%', textAlign: 'start'}}>{item.nameOrg}</p></h4>
                                                    </div>
                                                    <div className="services__page-item-left-content">
                                                        <a style={{color: 'red'}} target='_blank' href={item.link}>Read</a>
                                                    </div>
                                                </div>
                                                <div className='pr-card-box'>
                                                    {/* <div className="pr-carg-rating-container">
                                                        <p>Kills - {item.kills}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: (item.kills / firstValues.kills) * 100 < 25 ? "red" : (item.kills / firstValues.kills) * 100 < 75 ? '#ffc800' : (item.kills / firstValues.kills) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${(item.kills / firstValues.kills) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                    <div className="pr-carg-rating-container">
                                                        <p>K/D - {(item.kd / item.kdLen).toFixed(2)}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: ((item.kd / item.kdLen) / firstValues.kd) * 100 < 25 ? "red" : ((item.kd / item.kdLen) / firstValues.kd) * 100 < 75 ? '#ffc800' : ((item.kd / item.kdLen) / firstValues.kd) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${((item.kd / item.kdLen) / firstValues.kd) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                    <div className="pr-carg-rating-container">
                                                        <p>Tournaments - {item.tournament.length}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: (item.tournament.length / firstValues.tournaments) * 100 < 25 ? "red" : (item.tournament.length / firstValues.tournaments) * 100 < 75 ? '#ffc800' : (item.tournament.length / firstValues.tournaments) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${(item.tournament.length / firstValues.tournaments) * 100}%` }}></div>
                                                        </span>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                <FooterOne></FooterOne>        
            </> : <Preloader />
        }
    </>;
};

export default ScamPage;